import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useChatContext } from '../ChatContext/ChatContext.js'

export const CloseDetailsButton = () => {
  const { toggleShowChatDetails } = useChatContext()

  return (
    <>
      <IconButton
        variant="tertiaryNeutral"
        className="sm:hidden"
        icon={<SvgIcon name="close" />}
        onClick={() => toggleShowChatDetails()}
      />
      <IconButton
        variant="tertiaryNeutral"
        className="hidden sm:block"
        icon={<SvgIcon name="arrow-right" />}
        onClick={() => toggleShowChatDetails()}
      />
    </>
  )
}
